<div class="row justify-content-between">
  <div class="col-12">
    <nb-form-field>
      <input
        [ngModel]="name.value"
        type="text"
        nbInput
        fullWidth
        shape="rectangle"
        placeholder="Option"
        (ngModelChange)="update('name', $event)"
        (keydown.enter)="enterPressed.emit(true); $event.preventDefault()"
        [status]="name.untouched ? 'basic' : name.hasError ? 'danger' : 'success'"
        [id]="id"
      />
      <!-- <mat-icon nbSuffix matTooltip="A name appears in the collection form that your visitors fill in, exports and various places!" matTooltipPosition="above">
        help_outline
      </mat-icon> -->
    </nb-form-field>
    <p class="text-danger" *ngIf="slugAlreadyInUse()">
      {{ 'This is a duplicate value' }}
    </p>
  </div>
</div>
